import { Controller } from "@hotwired/stimulus"
import { default as $ } from 'jquery'

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = [
    "source",

    // The flash messages to show when the copy operation is successful or fails
    // These are appended to the #flashes element and are suppoeed a BannerComponent.
    // Example:
    //
    // ```html.erb
    //   <template data-clipboard-target="successFlash">
    //     <%= render BannerComponent.new(type: :success, auto_close: true) do %>
    //       Successfully copied to clipboard!
    //     <% end %>
    //   </template>
    // ```
    "successFlash",
    "errorFlash",
  ]

  copy(event) {
    event.preventDefault()
    let value = null

    const parseJson = this.sourceTarget.getAttribute("parse-json");

    if (parseJson === 'true') {
      const parsed = JSON.parse(this.sourceTarget.value);
      const fallbackLocale = this.sourceTarget.getAttribute("fallback-locale");

      value = this.formatValue(parsed, fallbackLocale);
    } else {
      value = this.sourceTarget.value;
    }

    navigator.clipboard.writeText(value).then(() => {
      this.showSuccessFlash()
    }).catch(() => {
      console.error('Failed to copy to clipboard')
      this.showErrorFlash()
    })
  }

  formatValue(value, fallbackLocale) {
    if (typeof value === "number") {
      return this.formatNumber(value, fallbackLocale);
    } else if (Array.isArray(value) || typeof value === "object") {
      return JSON.stringify(value);
    } else {
      return value;
    }
  }

  formatNumber(number, fallbackLocale) {
    const locale = navigator.language || fallbackLocale;
    return Number(number).toLocaleString(locale);
  }

  showSuccessFlash() {
    if (this.hasSuccessFlashTarget) {
      $('#flashes').append($(this.successFlashTarget.innerHTML))
    } else {
      this.showTooltip()
    }
  }

  showErrorFlash() {
    if (this.hasErrorFlashTarget) {
      $('#flashes').append($(this.errorFlashTarget.innerHTML))
    }
  }

  showTooltip() {
    // Create tooltip element
    const tooltip = document.createElement('div')
    tooltip.className = 'fixed z-50 bg-base-300 text-base-content text-xs px-2 py-1 rounded shadow-lg pointer-events-none opacity-0 transition-opacity duration-200'

    // Get localized text based on current locale
    const locale = document.documentElement.lang || 'en'
    const copiedText = locale === 'sv' ? 'Kopierad!' : 'Copied!'
    tooltip.textContent = copiedText

    // Get the position of the clicked element
    const rect = this.element.getBoundingClientRect()
    tooltip.style.left = `${rect.left + rect.width / 2}px`
    tooltip.style.top = `${rect.top - 8}px`
    tooltip.style.transform = 'translateX(-50%)'

    // Add to DOM
    document.body.appendChild(tooltip)

    // Animate in
    setTimeout(() => {
      tooltip.classList.remove('opacity-0')
      tooltip.classList.add('opacity-100')
    }, 10)

    // Animate out after 2 seconds
    setTimeout(() => {
      tooltip.classList.remove('opacity-100')
      tooltip.classList.add('opacity-0')

      // Remove from DOM after animation
      setTimeout(() => {
        if (tooltip.parentNode) {
          tooltip.parentNode.removeChild(tooltip)
        }
      }, 200)
    }, 2000)
  }
}
